import { render } from "./QuestionTwoScreen.vue?vue&type=template&id=ac77ec7a&scoped=true&lang=html"
import script from "./QuestionTwoScreen.vue?vue&type=script&lang=js"
export * from "./QuestionTwoScreen.vue?vue&type=script&lang=js"

import "./QuestionTwoScreen.vue?vue&type=style&index=0&id=ac77ec7a&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_rodi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac77ec7a"]])

export default __exports__